import { useContext, useEffect, useState } from "react";

import appStyles from "../../../App.module.css";
import { PortuguesePurchasePathContext } from "../../PortuguesePurchasePath";
import { IPortugueseInitialQuoteData, IPortuguesePurchasePathContext } from "../../config/interface";
import NextButton from "../buttons/NextButton";
import PrevButton from "../buttons/PrevButton";
import PPFooter from "../common/PPFooter";
import PPLoadingIndicator from "../common/PPLoadingIndicator";
import PPMobileFooter from "../common/PPMobileFooter";
import PPQuoteSummary from "../common/PPQuoteSummary";
import PPShowApiError from "../common/PPShowApiError";
import PPStepper from "../common/PPStepper";
import PPTripSummary from "../common/PPTripSummary";
import PPPackageSelector from "../page/PPPackageSelector";

const PPQuoteDetail = () => {
  const [firstLoad, setFirstLoad] = useState<boolean>(true);
  const [hasError, setHasError] = useState<string | null>(null);

  const { quoteData, next, setQuoteResult, packages, loader, previous, getQuote, setLoader } = useContext(
    PortuguesePurchasePathContext
  ) as IPortuguesePurchasePathContext;

  useEffect(() => {
    if (firstLoad) {
      setFirstLoad(false);
      return;
    }
    updateQuote();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [quoteData]);

  const updateQuote = async () => {
    try {
      setHasError(null);
      if (!Object.keys(quoteData.packages || {}).length) {
        return;
      }
      setLoader("quote");
      let _quoteData: IPortugueseInitialQuoteData = { ...quoteData };
      const _quoteResult = await getQuote(_quoteData);
      setQuoteResult(_quoteResult);
    } catch (e: any) {
      console.log(e);
      setHasError(e.message);
    } finally {
      setLoader(null);
    }
  };

  return (
    <>
      {loader === "quote" && <PPLoadingIndicator />}

      <div className={`${appStyles.mainContainer}`}>
        <div className={`${appStyles.quoteResultWrapper} ${appStyles.PPQuoteWrapper}`}>
          <div className={`${appStyles.quoteDetailsBox}`}>
            <div className={appStyles.headerWrapper}>
              <div className={appStyles.pageTitle}>
                <h2 className={`${appStyles.colorPrimary}`}>Your Quick Quote</h2>
              </div>
            </div>
            <PPStepper />

            <PPTripSummary />

            <div className={appStyles.pageSubTitle}>
              <h3 className={appStyles.colorPrimary}>
                {packages.length > 1 ? "Personalise your quote" : "Your quote"}
              </h3>

              {packages.length > 1 ? (
                <p>
                  You can select either&nbsp;
                  <b>Base Package</b>
                  &nbsp;or&nbsp;
                  <b>Base and Optional Package</b>
                </p>
              ) : null}
            </div>

            <div className={appStyles.collapseWrapper}>
              {packages?.map((pkg: any, index: number) => {
                return <PPPackageSelector key={index} pkg={pkg} />;
              })}
            </div>

            <div className={`${appStyles.paymentButtonWrapper} ${appStyles.formRow}`}>
              <div className={`${appStyles.buttonBlock} ${appStyles.buttonBlockNextPrev}`}>
                <PrevButton onClick={() => previous()} />
                <NextButton title="Checkout" onClick={() => next()} />
              </div>
            </div>

            {hasError && <PPShowApiError />}
            <PPFooter />

            <PPMobileFooter title={"checkout"} onClickBtn={() => next()} />
          </div>
          <PPQuoteSummary pay={false} quoteClass={appStyles.top10} />
        </div>
      </div>
    </>
  );
};

export default PPQuoteDetail;
